import { Server } from './Server'
import { LOCAL_STORAGE_KEYS } from 'src/config'

export function initServerFromLocalStorage() {
  const url = localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER_REGISTRY)
  if (!url) return

  try {
    const customerRegistry = JSON.parse(url)

    Server.defaults.auth = {
      username: process.env.REACT_APP_API_USER || 'MASTER',
      password: process.env.REACT_APP_API_PASSWORD || 'MASTER',
    }

    if (
      process.env.NODE_ENV === 'production' &&
      customerRegistry.clienteregistro_hostws
    ) {
      Server.defaults.baseURL = customerRegistry.clienteregistro_hostws.replace(
        /\\\//g,
        '/',
      )
    } else {
      Server.defaults.baseURL = process.env.REACT_APP_API_URL
    }
  } catch (e) {
    console.error('Erro ao restaurar CUSTOMER_REGISTRY do localStorage', e)
  }
}
